/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_NormalizationInputs */

const en_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalization`)
};

const ar_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التطبيع`)
};

const bn_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নরমালাইজেশন`)
};

const de_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalisierung`)
};

const es_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalización`)
};

const fr_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalisation`)
};

const pt_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalização`)
};

const zh_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准化`)
};

const tr_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalization`)
};

const ru_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нормализация`)
};

const pl_svchip_normalization = /** @type {(inputs: Svchip_NormalizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalizacja`)
};

/**
* | output |
* | --- |
* | "Normalization" |
*
* @param {Svchip_NormalizationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_normalization = /** @type {((inputs?: Svchip_NormalizationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_NormalizationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_normalization(inputs)
	if (locale === "bn") return bn_svchip_normalization(inputs)
	if (locale === "de") return de_svchip_normalization(inputs)
	if (locale === "es") return es_svchip_normalization(inputs)
	if (locale === "fr") return fr_svchip_normalization(inputs)
	if (locale === "pt") return pt_svchip_normalization(inputs)
	if (locale === "zh") return zh_svchip_normalization(inputs)
	if (locale === "tr") return tr_svchip_normalization(inputs)
	if (locale === "ru") return ru_svchip_normalization(inputs)
	if (locale === "pl") return pl_svchip_normalization(inputs)
	return en_svchip_normalization(inputs)
});